var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9036 2.5 27.5 8.09644 27.5 15C27.5 21.9036 21.9036 27.5 15 27.5C8.09644 27.5 2.5 21.9036 2.5 15Z",
    fill: "#095228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6498 16.5734C9.6498 16.8109 9.7373 17.0484 9.9248 17.2359C10.2873 17.5984 10.8873 17.5984 11.2498 17.2359L14.9998 13.4859L18.7498 17.2359C19.1123 17.5984 19.7123 17.5984 20.0748 17.2359C20.4373 16.8734 20.4373 16.2734 20.0748 15.9109L15.6623 11.4984C15.2998 11.1359 14.6998 11.1359 14.3373 11.4984L9.9248 15.9109C9.7373 16.0984 9.6498 16.3359 9.6498 16.5734Z",
    fill: "#095228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.01d64a25d091f200aef1879b99592f26.svg";
export { ForwardRef as ReactComponent };